export function pushAddToWishlistEvent(data) {

    window.dataLayer.push({
        productSku: data.sku,
        productPrice: data.price,
        productBrand: data.brand,
        productCategory: data.category,
        event: 'addToWL'
    });
}

export function pushRemoveFromWishlistEvent(data) {

    window.dataLayer.push({
        productSku: data.sku,
        productPrice: data.price,
        event: 'removeFromWL'
    });
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/wishlist/baseWishlistButtonEvents.js
 **/